import { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

export const IconLeft = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 16} height={props.height || 17} viewBox="0 0 16 17" fill="none" style={props.style}>
      <g>
        <path
          d="M10 12.5L6 8.5L10 4.5"
          stroke={props.stroke || theme.colors.text.primary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </IconBase>
  )
}
